<template>
  <v-card>
    <v-card-title>
      <div class="mr-2">{{ $t('settings.clearlyaw.title') }}</div>
      <cp-help i18n="clearlyaw"/>
    </v-card-title>
    <v-card-text>
      <template v-for="(link, idx) in downloads">
        <v-tooltip bottom :key="idx">
          <template v-slot:activator="{ on, attrs }">
            <v-btn :color="link.color" icon class="mx-2"
              @click="openLink(link.URL)"
              v-on="on" v-bind="attrs">
              <v-icon>{{ link.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('settings.clearlyaw.tooltip.' + link.tooltip) }}</span>
        </v-tooltip>
      </template>

      <span class="ml-16">
        <v-tooltip bottom v-if="showMoreInfo">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon large color="teal lighten-2"
              @click="openLink(helpLink)"
              class="mx-2" v-on="on" v-bind="attrs">
              <v-icon>mdi-help-box</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('settings.clearlyaw.tooltip.help') }}</span>
        </v-tooltip>
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import API from '@/api'

export default {
  name: 'clearly-anywhere',
  data () {
    return {
      showMoreInfo: false,
      helpLink: 'https://www.clearlyip.com/products/clearly-anywhere',
      downloads: [
        {
          icon: 'mdi-google-play',
          color: 'primary',
          URL: 'https://play.google.com/store/apps/details?id=com.clearlyip.anywhere.android',
          tooltip: 'googlePlay'
        }, {
          icon: 'mdi-apple',
          color: 'grey',
          URL: 'https://apps.apple.com/us/app/clearly-anywhere/id1528175108',
          tooltip: 'appleStore'
        }
      ]
    }
  },
  mounted () {
    this.getMoreInfoLinkState()
  },
  methods: {
    openLink: function (url) {
      window.open(url, '_blank')
    },
    getMoreInfoLinkState: function () {
      API.getClearlyAnywhereMoreInfoLinkState().then(({ data }) => {
        if (data.success && data.enabled) {
          this.showMoreInfo = true
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
